import React, { useState, useEffect } from 'react';
import { alpha, Checkbox, Grid, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import cx from 'classnames'
import {makeStyles} from '@mui/styles'

/**
 * @module Layouts/Registration/components/AddressOption
 * @description This is a React component that renders an address option with a checkbox and allows the user to
 * select it.
 */

/**
 * 
 * @typedef AddressOption
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Object} address - The address element as an object
 * @property {Number} address.id - The id of the address
 * @property {String} address.delivery_line_1 - First line of address data
 * @property {String} address.last_line - Second line of address data
 * @property {Boolean} selected - Variable that handles if an address is selected or not
 * @property {Function} onSelected - This function is dispatched when this Address Option is clicked
 
 * @returns A functional component called AddressOption is being returned. It takes in props such as
 * address, selected, and onSelected, and renders a div with a Grid container inside. The Grid
 * container has two Grid items, one for a Checkbox and the other for a Typography component that
 * displays the delivery line and last line of the address. The div has conditional styling based on
 * whether it is selected or not. When
 */
const AddressOption = (props) => {

    const {address, selected, onSelected} = props
    const classes = useStyles()

    return ( 
        <div className={cx({
            [classes.root]:true, 
            [classes.root_selected]:selected,
            
        })}
        onClick={() => onSelected(address)}>
            <Grid container spacing={1}>
                <Grid item>
                    <Checkbox checked={selected} />
                </Grid>
                <Grid item xs>
                    <div>
                        <Typography variant={selected ? 'subtitle1' : 'body1'}>
                            {address?.delivery_line_1}
                        </Typography>
                        <Typography variant={selected ? 'subtitle1' : 'body1'}>
                            {address?.last_line}
                        </Typography>
                    </div>
                </Grid>
            </Grid>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    root:{
        border:`1px dashed ${grey[300]}`,
        borderRadius:8,
        padding:8,
        cursor:'pointer',
        '&:hover':{
            background:alpha(theme.palette.secondary.main,0.25),
            transition:'all 0.3s linear'
        },
        transition:'all 0.3s linear'
    },
    root_selected:{
        border:`2px solid ${theme.palette.secondary.main}`,
        transition:'all 0.2s linear'
    }
}))
 
export default AddressOption;